export default __webpack_public_path__ + "static/media/slot-m.0e0993a2.webp";